'use client';

import DMCommand from '@/components/select/DMCommand';
import useOneOnOneStore from '@/lib/zustand/store/oneOnOneStore';
import getTimezoneData from '../utils/timeZones';

const { groupLookupMap, timeZoneMap } = getTimezoneData();

export default function TimezonePicker() {
  const { timeZone, setTimeZone } = useOneOnOneStore();
  //   const {
  //     state: { timeZone },
  //     dispatch,
  //   } = useProvider();

  // In the case we resolve to a timezone that isn’t the representative
  // timezone used in the dropdown box, "snap" the selected timezone to
  // the best candidate invisibly.
  const selectedTimeZoneValue = groupLookupMap.get(timeZone);

  const commandItems = [
    {
      group: 'Time Zones',
      items: Array.from(timeZoneMap).map(([display, { value }]) => ({
        key: `GMT${display}`,
        value,
      })),
    },
  ];
  return (
    <div className='w-full max-w-2xl'>
      <p className='block text-sm font-medium leading-0 mb-2'>Timezone</p>

      {/* <select
        value={selectedTimeZoneValue}
        id='location'
        name='location'
        className='mt-1 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-accent-600 sm:text-sm sm:leading-6 overflow-x-clip'
        onChange={e => {
          setTimeZone(e.target.value);
        }}
      >
        {Array.from(timeZoneMap).map(([display, { value }]) => (
          <option key={display} value={value}>
            {`GMT${display}`}
          </option>
        ))}
      </select> */}
      <DMCommand
        selectedTimeZoneValue={selectedTimeZoneValue}
        items={commandItems}
        onClick={setTimeZone}
        placeholder='Search or type a timezone...'
      />
    </div>
  );
}
